import React, { useEffect } from 'react';
import Row from './Row';
import Counter from 'components/Counter';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { useZod } from "../../../services/api/ApiClient";
import { useDateRangeFilter } from "../../../components/DateRangeSelector/useDateRangeFilter";

const CounterPerType: React.FC = props => {
  const {zodiosHooks} = useZod();
  const { dateRange, dateFilterRange } = useDateRangeFilter();
  const {data, mutate, isLoading} =  zodiosHooks.usePostApiabpDashboardstatistiekentype();

  useEffect(() => {
    retrieveData();
  }, [dateFilterRange]);
  const retrieveData = () => {
    const request = {
      datumVan: dateRange.start.toISOString(),
      datumTm: dateRange.end.toISOString(),
    };
    mutate({...request});
  };
  
  return (
    <Row title="Berichten per type">
      {isLoading ? (
        <Spinner size={SpinnerSize.large} />
      ) : (
        <>
          <Counter number={data?.aantalOpdrachtBerichten ?? 0} text={'Opdrachtberichten'} />
          <Counter number={data?.aantalStatusBerichten ?? 0} text={'Statusberichten'} />
          <Counter number={data?.aantalFactuurBerichten ?? 0} text={'Factuurberichten'} />
        </>
      )}
    </Row>
  );
};

export default CounterPerType;
